import FragmentEditor from './FragmentEditor'

export default FragmentEditor
